<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import { computed } from 'vue';

import Checkbox from '@/components/base/form/Checkbox.vue';
import FormControlsWrapper from '@/components/base/form/FormControlsWrapper.vue';

const props = defineProps<{
  addressKey: string;
  modelValue: boolean;
  heatResistantPackagingIncluded?: boolean;
}>();

const emit = defineEmits<{ 'update:modelValue': [boolean] }>();

const addHeatResistantPackaging = useVModel(props, 'modelValue', emit);

const highlight = computed(
  (): boolean => props.heatResistantPackagingIncluded || addHeatResistantPackaging.value,
);
</script>

<template>
  <FormControlsWrapper :selected="addHeatResistantPackaging">
    <Checkbox
      v-model="addHeatResistantPackaging"
      class="mt-1 font-normal"
      data-test="heat-resistant-packaging-checkbox"
      :disabled="heatResistantPackagingIncluded"
      :checked="addHeatResistantPackaging"
    >
      <div class="flex justify-between w-full">
        <div class="ml-1 mr-5">
          <div :class="{ 'font-bold': highlight }">Use Heat-Resistant Packaging</div>
          <div class="text-xs md:text-sm text-neutral-600">
            Protect your yummies from melting during transit with heat-resistant packaging
          </div>
        </div>
        <div :class="{ 'font-bold': highlight }">
          {{ heatResistantPackagingIncluded ? 'FREE' : '$2.95' }}
        </div>
      </div>
    </Checkbox>
  </FormControlsWrapper>
</template>
